<p8-bdc-documents [selectingMode]="true" (documentSelected)="onSelected($event)"></p8-bdc-documents>
